import FishLogo from "@components/icons/FishLogo";
import { FC } from "react";

type M62IconRendererProps = {
    icon: string;
    sizeInPx?: number;
    placement?: "LEFT" | "CENTER" | "RIGHT";
};

const icons: { [key: string]: FC<any> } = {
    FishLogo,
};

const M62IconRenderer: FC<M62IconRendererProps> = ({
    icon,
    sizeInPx,
    placement
}) => {
    const IconComponent = icons[icon];

    if (!IconComponent) {
        console.error(`Icon "${icon}" does not exist.`);
        return null;
    }

    const { width, height } = sizeInPx
        ? { width: sizeInPx, height: sizeInPx }
        : { width: 30, height: 30 };

    return (
        <IconComponent
            width={width}
            height={height}
            className={
                placement === "RIGHT"
                    ? "ml-auto"
                    : placement === "CENTER"
                        ? "mx-auto" : ""
            }
        />
    );
};

export default M62IconRenderer;